import MenuProductCard from '../Marketplace/MenuProductCard';

/**
 * Productos de una categoría del menú, a dos columnas. El espacio entre
 * columnas y renglones sale de la referencia (≈10px entre tarjetas).
 */
const ProductGrid = ({ products, onProductClick, unavailableTagImage, addButtonImage }) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-x-2.5 gap-y-6">
      {products.map((product) => (
        <MenuProductCard
          key={product._id || product.id}
          product={product}
          unavailableTagImage={unavailableTagImage}
          addButtonImage={addButtonImage}
          onClick={() => onProductClick?.(product)}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
